export default "__VITE_ASSET__CFuKoUbY__"